<div class="details">

  @if (error.occured) {
    <div class="error">
      {{error.text}}
    </div>
  }

  <app-input-form
    id="amazonLink" label="Amazon URL"
    [form]="form"
    [required]="true"
    [buttonText]="buttonText"
    (buttonClick)="scrapeLink()"
    [disabled]="scrapeInProgress"
  ></app-input-form>

  <div class="flex">
    <!-- <div class="flex-item">
    <app-book-cover (coverUploaded)="updateCover($event)"></app-book-cover>

  </div> -->
  <div class="flex-item">

    <!-- <app-input-form id="title" label="Book Title" [required]="true" [form]="form"></app-input-form>
    <app-input-form id="author" label="Author" [required]="true" [form]="form"></app-input-form>
    <app-textarea-form id="description" label="Book Description for Promotion" [required]="true" [form]="form"></app-textarea-form>
    <p class='subtext'>*Must be 350 characters or less. Please don't copy from Amazon.</p>

    <div style="clear:both"></div>
    <button class="button" (click)="continue()">Continue</button> -->
  </div>
</div>
</div>
